import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'

// 应用vuex插件
Vue.use(Vuex)
// console.log('user',user)
// console.log('getters',getters)
// 创建并暴露store
const store = new Vuex.Store({
  modules: {
    user
  },
  getters
})
// console.log(888,store)
export default store